// extracted by mini-css-extract-plugin
export default {"ppe-icon-actions":"Places_ppe-icon-actions__gGRpn","edit":"Places_edit__Ne86Y","delete":"Places_delete__z4nco"};